import TermSet from '@rdf-esm/term-set';
import { sparql } from '@tpluscode/rdf-string';
export default function () {
  const builder = {
    defaultGraph: new TermSet(),
    fromNamed: new TermSet(),

    fromClause() {
      const clause = [...this.defaultGraph.values()].reduce((current, graph) => sparql`${current}\nFROM ${graph}`, sparql``);
      return [...this.fromNamed.values()].reduce((current, graph) => sparql`${current}\nFROM NAMED ${graph}`, clause);
    }

  };
  return { ...builder,

    FROM(defaultGraph) {
      if (!defaultGraph) {
        return {
          NAMED: graph => {
            this.fromNamed.add(graph);
            return this;
          }
        };
      }

      if (defaultGraph.termType === 'DefaultGraph') {
        this.defaultGraph.clear();
      } else {
        this.defaultGraph.add(defaultGraph);
      }

      return this;
    }

  };
}